<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-bottom="6"
        offset-y
        left
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn text small v-bind="attrs" v-on="on">
                <v-badge
                    :value="total > 0"
                    :content="total"
                    color="primary"
                    overlap
                >
                    <v-icon small>mdi-filter-variant</v-icon>
                </v-badge>
                <span v-if="$vuetify.breakpoint.smAndUp" class="ml-3">Filtros</span>
                <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
        </template>

        <v-card :width="largura">
            <v-card-title class="py-3">
                <span class="text-subtitle-1">Filtros</span>
                <v-spacer/>
                <v-btn icon small @click="menu = false">
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-divider/>

            <v-card-text :style="`max-height: ${alturaCorpo}px; overflow-y: auto;`">
                <div
                    v-for="(grupo, index) in grupos"
                    :key="grupo"
                    :class="index ? 'mt-4' : ''"
                >
                    <div class="text-overline grey--text mb-1">{{ grupo }}</div>

                    <v-row dense>
                        <v-col
                            v-for="campo in camposDoGrupo(grupo)"
                            :key="campo.chave"
                            cols="12"
                            :sm="campo.cols"
                        >
                            <v-select
                                v-if="campo.tipo === 'multi'"
                                v-model="local[campo.chave]"
                                :items="campo.opcoes"
                                :label="campo.titulo"
                                :hint="campo.dica"
                                :persistent-hint="!!campo.dica"
                                outlined
                                dense
                                multiple
                                small-chips
                                clearable
                            >
                                <template v-slot:selection="{ item, index: i }">
                                    <v-chip v-if="i === 0" x-small>
                                        <span>{{ item.text }}</span>
                                    </v-chip>
                                    <span v-if="i === 1" class="grey--text text-caption">
                                        (+{{ local[campo.chave].length - 1 }})
                                    </span>
                                </template>
                            </v-select>

                            <v-select
                                v-else-if="campo.tipo === 'select'"
                                v-model="local[campo.chave]"
                                :items="campo.opcoes"
                                :label="campo.titulo"
                                :hint="campo.dica"
                                :persistent-hint="!!campo.dica"
                                :clearable="campo.padrao === undefined"
                                outlined
                                dense
                            />

                            <v-text-field
                                v-else-if="campo.tipo === 'data'"
                                v-model="local[campo.chave]"
                                :label="campo.titulo"
                                type="date"
                                outlined
                                dense
                                hide-details
                                clearable
                            />

                            <v-text-field
                                v-else
                                v-model="local[campo.chave]"
                                :label="campo.titulo"
                                :prefix="campo.prefixo"
                                :suffix="campo.sufixo"
                                :hint="campo.dica"
                                :persistent-hint="!!campo.dica"
                                type="number"
                                :min="campo.min !== undefined ? campo.min : 1"
                                outlined
                                dense
                                clearable
                            />
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-btn text small :disabled="!total" @click="limpar">Limpar tudo</v-btn>
                <v-spacer/>
                <v-btn color="primary" small @click="aplicar">Aplicar</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    name: 'FiltrosMenu',

    props: {
        value: {
            type: Object,
            required: true,
        },

        catalogo: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            menu: false,
            local: this.catalogo.normalizarFiltros(this.value),
        };
    },

    computed: {
        campos() {
            return this.catalogo.CAMPOS;
        },

        grupos() {
            return this.catalogo.GRUPOS;
        },

        total() {
            return this.catalogo.totalAtivos(this.value);
        },

        largura() {
            return this.$vuetify.breakpoint.smAndDown ? 320 : 760;
        },

        alturaCorpo() {
            return Math.max(260, this.$vuetify.breakpoint.height - 300);
        },
    },

    watch: {
        menu(aberto) {
            if (aberto) {
                this.local = this.catalogo.normalizarFiltros(this.value);
            }
        },

        value: {
            deep: true,
            handler(novo) {
                if (!this.menu) {
                    this.local = this.catalogo.normalizarFiltros(novo);
                }
            },
        },
    },

    methods: {
        camposDoGrupo(grupo) {
            return this.catalogo.camposDoGrupo(grupo);
        },

        aplicar() {
            this.menu = false;
            this.$emit('input', this.catalogo.normalizarFiltros(this.local));
            this.$emit('aplicar');
        },

        limpar() {
            this.local = this.catalogo.filtrosPadrao();
            this.aplicar();
        },
    },
};
</script>
